import { useEffect, useRef } from "react";

// Fades and lifts content in once as it scrolls into view. It stays fully visible if this never runs,
// for anything already on screen, and for anyone who prefers reduced motion.
export function Reveal({ delay = 0, className = "", children, testid }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || !("IntersectionObserver" in window) || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    if (el.getBoundingClientRect().top < window.innerHeight * 0.92) return undefined;
    el.dataset.reveal = "hidden";
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      el.dataset.reveal = "shown";
      io.disconnect();
    }, { rootMargin: "0px 0px -6% 0px", threshold: 0.05 });
    io.observe(el);
    return () => { io.disconnect(); delete el.dataset.reveal; };
  }, []);
  return <div ref={ref} className={className} style={delay ? { transitionDelay: `${delay}ms` } : undefined} data-testid={testid}>{children}</div>;
}
